<kuv-table [items]="tableItems" [columns]="columnas" [useFilter]="false" [usePagination]="false" [actions]="[]"></kuv-table>